
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("l6iDs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "Trackers", () => $cbbc16525f32fd14$export$a2c5350cd99575c4);
$parcel$export(module.exports, "default", () => $cbbc16525f32fd14$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bnesV = parcelRequire("bnesV");

var $hE335 = parcelRequire("hE335");

var $dmo0c = parcelRequire("dmo0c");

var $5DN9C = parcelRequire("5DN9C");
const $cbbc16525f32fd14$export$a2c5350cd99575c4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5DN9C.SpaTransitionResources), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hE335.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bnesV.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dmo0c.default), null));
var $cbbc16525f32fd14$export$2e2bcd8739ae039 = $cbbc16525f32fd14$export$a2c5350cd99575c4;

});
parcelRegister("bnesV", function(module, exports) {

$parcel$export(module.exports, "default", () => $315b949083dfa45f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2jDha = parcelRequire("2jDha");

var $e91YZ = parcelRequire("e91YZ");

var $5GxEP = parcelRequire("5GxEP");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

const $315b949083dfa45f$var$FireDevopsTargetingEvents = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    // This tenant context value is set only when the user signs up for a devops instance.
    const isDevopsSite = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)().isDevopsProjectCreationScenario;
    (0, $eUqFw.useEffect)(()=>{
        if (isDevopsSite) (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'devopsSite visited');
    }, [
        createAnalyticsEvent,
        isDevopsSite
    ]);
    return null;
};
const $315b949083dfa45f$var$WithAnalyticsFireDevopsTargetingEvents = (0, $2jDha.default)()($315b949083dfa45f$var$FireDevopsTargetingEvents);
const $315b949083dfa45f$var$SafeWithAnalyticsFireDevopsTargetingEvents = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: (0, $8b8167738b60b26d$export$8be180ec26319f9f),
        packageName: (0, $8b8167738b60b26d$export$b8b9d90f9e5bd72b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($315b949083dfa45f$var$WithAnalyticsFireDevopsTargetingEvents, null));
var $315b949083dfa45f$export$2e2bcd8739ae039 = $315b949083dfa45f$var$SafeWithAnalyticsFireDevopsTargetingEvents;

});
const $8b8167738b60b26d$export$b8b9d90f9e5bd72b = 'jiraSpaAppsDevopsFireTargetingEvents';
const $8b8167738b60b26d$export$8be180ec26319f9f = 'devopsFireTargetingEvents';


parcelRegister("hE335", function(module, exports) {

$parcel$export(module.exports, "default", () => $71fba6dbdc40b282$export$2e2bcd8739ae039);

var $3O7TI = parcelRequire("3O7TI");

var $4LERb = parcelRequire("4LERb");

var $e91YZ = parcelRequire("e91YZ");

var $knPb9 = parcelRequire("knPb9");

var $aIG68 = parcelRequire("aIG68");

var $c4Z7t = parcelRequire("c4Z7t");

var $3UdDr = parcelRequire("3UdDr");
var $71fba6dbdc40b282$export$2e2bcd8739ae039 = (0, $knPb9.default)((0, $aIG68.default), {
    onJswJsdBundleCheck: ()=>(0, $3O7TI.default)() && (0, $4LERb.default)(),
    onJswConfluenceBundleCheck: ()=>(0, $c4Z7t.default)() && (0, $3UdDr.default)(),
    onGetFirstActivationDate: ()=>(0, $e91YZ.getFirstActivationDate)()
});

});
parcelRegister("3O7TI", function(module, exports) {

$parcel$export(module.exports, "default", () => $df5a308dc9ea0953$export$2e2bcd8739ae039);

var $e91YZ = parcelRequire("e91YZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$df5a308dc9ea0953$export$2e2bcd8739ae039 = ()=>{
    const products = (0, $e91YZ.getLicensedProducts)();
    const { JIRA_SOFTWARE: JIRA_SOFTWARE, JIRA_SERVICEDESK: JIRA_SERVICEDESK } = (0, $e91YZ.LICENSED_PRODUCTS);
    return products[JIRA_SOFTWARE] && products[JIRA_SERVICEDESK];
};

});

parcelRegister("4LERb", function(module, exports) {

$parcel$export(module.exports, "default", () => $d54058f1ef89d45c$export$2e2bcd8739ae039);

var $e91YZ = parcelRequire("e91YZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d54058f1ef89d45c$export$2e2bcd8739ae039 = ()=>{
    const { JIRA_SOFTWARE: JIRA_SOFTWARE, JIRA_SERVICEDESK: JIRA_SERVICEDESK } = (0, $e91YZ.LICENSED_PRODUCTS);
    const initialProductList = (0, $e91YZ.getInitialProductList)();
    return initialProductList !== undefined && initialProductList.startsWith(`${JIRA_SOFTWARE}.ondemand,${JIRA_SERVICEDESK}.ondemand`);
};

});

parcelRegister("aIG68", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f1b20110d446b40$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2jDha = parcelRequire("2jDha");

var $jMP2a = parcelRequire("jMP2a");
const $3f1b20110d446b40$var$SEVEN_DAYS_IN_MS = 604800000;
class $3f1b20110d446b40$export$7b4bc8546790dc76 extends (0, $eUqFw.Component) {
    static{
        this.displayName = 'FireEngagementTargetingEvents';
    }
    componentDidMount() {
        const { onJswConfluenceBundleCheck: onJswConfluenceBundleCheck, onJswJsdBundleCheck: onJswJsdBundleCheck, createAnalyticsEvent: createAnalyticsEvent, onGetFirstActivationDate: onGetFirstActivationDate } = this.props;
        const isJswConfluenceBundle = onJswConfluenceBundleCheck();
        const isJswJsdBundle = onJswJsdBundleCheck();
        const firstActivationDate = onGetFirstActivationDate();
        const currentTime = Date.now();
        const timeSinceInstanceActivation = firstActivationDate !== null ? currentTime - firstActivationDate : null;
        if (timeSinceInstanceActivation !== null && timeSinceInstanceActivation > 0 && timeSinceInstanceActivation < $3f1b20110d446b40$var$SEVEN_DAYS_IN_MS) {
            if (isJswConfluenceBundle) (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'appswitcherSpotlight targeting');
            if (isJswJsdBundle) (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'appswitcherjsdspotlight targeting');
        }
    }
    render() {
        return null;
    }
}
var $3f1b20110d446b40$export$2e2bcd8739ae039 = (0, $2jDha.default)()($3f1b20110d446b40$export$7b4bc8546790dc76);

});

parcelRegister("c4Z7t", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d73eaae9ded55ed$export$2e2bcd8739ae039);

var $e91YZ = parcelRequire("e91YZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7d73eaae9ded55ed$export$2e2bcd8739ae039 = ()=>{
    const products = (0, $e91YZ.getLicensedProducts)();
    const { JIRA_SOFTWARE: JIRA_SOFTWARE, CONFLUENCE: CONFLUENCE } = (0, $e91YZ.LICENSED_PRODUCTS);
    return products[JIRA_SOFTWARE] && products[CONFLUENCE];
};

});

parcelRegister("3UdDr", function(module, exports) {

$parcel$export(module.exports, "default", () => $88b415b2fe5a490b$export$2e2bcd8739ae039);

var $e91YZ = parcelRequire("e91YZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$88b415b2fe5a490b$export$2e2bcd8739ae039 = ()=>{
    const { JIRA_SOFTWARE: JIRA_SOFTWARE, CONFLUENCE: CONFLUENCE } = (0, $e91YZ.LICENSED_PRODUCTS);
    const initialProductList = (0, $e91YZ.getInitialProductList)();
    return initialProductList !== undefined && initialProductList.startsWith(`${JIRA_SOFTWARE}.ondemand,${CONFLUENCE}.ondemand`);
};

});


parcelRegister("dmo0c", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef97e2a7771397a2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $ef97e2a7771397a2$var$LegacyIssueCreateTrackers = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const trackLegacyIssueCreate = (0, $eUqFw.useCallback)((event)=>{
        if (!(event instanceof CustomEvent)) return;
        const payload = event.detail;
        const trackEvent = createAnalyticsEvent({});
        (0, $jMP2a.fireTrackAnalytics)(trackEvent, 'issueCreated inProductSurvey', payload.objectId, {
            ...payload.attributes
        });
    }, [
        createAnalyticsEvent
    ]);
    (0, $eUqFw.useEffect)(()=>{
        document.addEventListener('legacy_legacyIssueCreated', trackLegacyIssueCreate);
        return ()=>document.removeEventListener('legacy_legacyIssueCreated', trackLegacyIssueCreate);
    }, [
        createAnalyticsEvent,
        trackLegacyIssueCreate
    ]);
    return null;
};
var $ef97e2a7771397a2$export$2e2bcd8739ae039 = $ef97e2a7771397a2$var$LegacyIssueCreateTrackers;

});

parcelRegister("5DN9C", function(module, exports) {

$parcel$export(module.exports, "SpaTransitionResources", () => $95383da6fe61949e$export$48fe79d11c18f082);

var $2jDha = parcelRequire("2jDha");

var $9v2XE = parcelRequire("9v2XE");

const $95383da6fe61949e$export$48fe79d11c18f082 = (0, $2jDha.default)()(// @ts-expect-error - TS2345 - Argument of type '({ createAnalyticsEvent, }: SpaResourceMetricsControllerWithActionsProps) => JSX.Element' is not assignable to parameter of type '(((props: WithAnalyticsEventsProps) => ReactElement<any, string | ((props: any) => ReactElement<any, any> | null) | (new (props: any) => Component<any, any, any>)> | null) & (({ createAnalyticsEvent, }: SpaResourceMetricsControllerWithActionsProps) => Element)) | ((new (props: WithAnalyticsEventsProps) => Component<...'.
(0, $9v2XE.SpaResourceMetricsControllerWithActions));

});
parcelRegister("9v2XE", function(module, exports) {

$parcel$export(module.exports, "SpaResourceMetricsControllerWithActions", () => $5263ffd4ad105e59$export$89f414cc1bd7e863);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $6rW04 = parcelRequire("6rW04");

var $jMP2a = parcelRequire("jMP2a");

var $6qExu = parcelRequire("6qExu");

var $lcJyp = parcelRequire("lcJyp");

var $78d1w = parcelRequire("78d1w");

var $lB25E = parcelRequire("lB25E");

var $4ea83 = parcelRequire("4ea83");
const $5263ffd4ad105e59$var$defaultMetrics = {
    type: null,
    duration: null,
    end: null,
    isCacheHit: null,
    start: 0
};
const $5263ffd4ad105e59$var$canSendMetrics = ({ duration: duration, end: end, isCacheHit: isCacheHit, start: start })=>isCacheHit !== $5263ffd4ad105e59$var$defaultMetrics.isCacheHit && duration !== $5263ffd4ad105e59$var$defaultMetrics.duration && start !== $5263ffd4ad105e59$var$defaultMetrics.start && end !== $5263ffd4ad105e59$var$defaultMetrics.end;
const $5263ffd4ad105e59$var$isCachedResource = (slice, invocationTimestamp)=>!slice.loading && (slice.expiresAt ?? 0) > invocationTimestamp;
const $5263ffd4ad105e59$var$SAMPLING_RATE = 10;
const $5263ffd4ad105e59$var$ResourceMetricTracker = ({ resource: resource, route: currentRoute, createAnalyticsEvent: createAnalyticsEvent, setResourceMetrics: setResourceMetrics, currentMatch: currentMatch, isInitialRender: isInitialRender })=>{
    const [metrics, setMetrics] = (0, $eUqFw.useState)($5263ffd4ad105e59$var$defaultMetrics);
    const [isSent, setIsSent] = (0, $eUqFw.useState)(false);
    const slice = (0, $lB25E.useResource)(resource);
    (0, $eUqFw.useEffect)(()=>// clear metrics on route change
        ()=>{
            setMetrics({
                ...$5263ffd4ad105e59$var$defaultMetrics
            });
            setIsSent(false);
        }, [
        currentRoute
    ]);
    // watch the resource and update metrics
    (0, $eUqFw.useEffect)(()=>{
        if (slice.expiresAt === null || isSent) // don't record metrics until the slice has an expiry set
        return;
        const invocationTimestamp = Date.now();
        if (metrics.isCacheHit === null && $5263ffd4ad105e59$var$isCachedResource(slice, invocationTimestamp)) {
            // cached resource
            setMetrics((state)=>({
                    ...state,
                    duration: 0,
                    end: invocationTimestamp,
                    isCacheHit: true,
                    start: invocationTimestamp,
                    type: resource.type
                }));
            return;
        }
        if (slice.loading && metrics.start === 0) {
            // set start time
            setMetrics((state)=>({
                    ...state,
                    type: resource.type,
                    isCacheHit: false,
                    start: invocationTimestamp
                }));
            return;
        }
        if (!slice.loading && metrics.start !== $5263ffd4ad105e59$var$defaultMetrics.start && metrics.end === $5263ffd4ad105e59$var$defaultMetrics.end) // set end time
        setMetrics((state)=>({
                ...state,
                duration: invocationTimestamp - state.start,
                end: invocationTimestamp
            }));
    }, [
        isSent,
        currentRoute,
        metrics,
        resource,
        slice
    ]);
    // watch the metrics object and send event when it has enough data
    (0, $eUqFw.useEffect)(()=>{
        const { error: error } = slice;
        if (isSent || !$5263ffd4ad105e59$var$canSendMetrics(metrics) || // Always send error events but sample success events (1 in every 10)
        !error && Math.random() * 100 > $5263ffd4ad105e59$var$SAMPLING_RATE) return;
        const { isCacheHit: isCacheHit, duration: duration, start: start, end: end, type: resourceType } = metrics;
        const action = error ? 'fetchFailed' : 'fetchSucceeded';
        const analyticsEvent = createAnalyticsEvent({
            action: action
        });
        const errorMessage = error && error instanceof Error ? error.toString() : error;
        const routeName = currentRoute.name ? currentRoute.name : 'empty';
        (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, `${action} resource`, resource.type, {
            duration: duration,
            isCacheHit: isCacheHit,
            start: start,
            end: end,
            routeName: routeName,
            prefetchStartTime: (0, $4ea83.getPrefetchStartMark)(currentMatch),
            isInitialRender: isInitialRender,
            resourceType: resourceType,
            ...errorMessage !== null && errorMessage !== undefined ? {
                error: errorMessage
            } : {}
        });
        if (error) {
            (0, $guiFP.default)({
                meta: {
                    id: `spaTransitionResources.${(resourceType || '').toLowerCase()}`,
                    packageName: 'jiraSpaTransitionResourcesTracker',
                    teamName: 'magma'
                },
                attributes: {
                    // Filter out synthetic tests using all known ways
                    isSynthetic: (0, $6rW04.default)('ajs-is-synthetic') === 'true' || (0, $1ybV0.ff)('issue.details.forge-ui-synthetic-check')
                },
                error: // @ts-expect-error - TS2322 - Type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error)' is not assignable to type 'Error | undefined'.
                error,
                skipSentry: true
            });
            (0, $gUUjF.default).safeErrorWithoutCustomerData(`resources.${(resourceType || '').toLowerCase()}`, // @ts-expect-error - TS2345 - Argument of type 'string | Record<string, any>' is not assignable to parameter of type 'string'.
            errorMessage || '', error);
        }
        // add the resource metrics to the spa state store
        setResourceMetrics({
            end: // @ts-expect-error - TS2322 - Type 'number | null' is not assignable to type 'number'.
            end,
            isCacheHit: // @ts-expect-error - TS2322 - Type 'boolean | null' is not assignable to type 'boolean'.
            isCacheHit,
            start: start,
            // @ts-expect-error - TS2322 - Type 'string | null' is not assignable to type 'string'.
            type: resourceType
        });
        setIsSent(true);
    }, [
        createAnalyticsEvent,
        currentRoute,
        isSent,
        metrics,
        setResourceMetrics,
        slice,
        resource,
        currentMatch,
        isInitialRender
    ]);
    return null;
};
const $5263ffd4ad105e59$export$b5bbbe33c7801196 = ({ createAnalyticsEvent: createAnalyticsEvent, setResourceMetrics: setResourceMetrics })=>{
    const [{ route: currentRoute, match: currentMatch }] = (0, $lB25E.useRouter)();
    const [{ isInitialRender: isInitialRender }] = (0, $78d1w.useSpaStateTransition)();
    (0, $eUqFw.useEffect)(()=>{
        (0, $4ea83.clearPrefetchStartMarks)(currentMatch);
    }, [
        currentMatch
    ]);
    const resourcesToTrack = (0, $eUqFw.useMemo)(()=>{
        // exclude resources that are turned off by feature flags
        const resources = currentRoute?.resources?.filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resource)=>resource.type !== (0, $6qExu.RESOURCE_TYPE_NOOP)) || [];
        return resources.map((resource)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5263ffd4ad105e59$var$ResourceMetricTracker, {
                key: resource.type,
                resource: resource,
                route: currentRoute,
                currentMatch: currentMatch,
                createAnalyticsEvent: createAnalyticsEvent,
                setResourceMetrics: setResourceMetrics,
                isInitialRender: isInitialRender
            }));
    // disabling lint as we are triggering the re-render with props that are not directly used
    }, [
        currentRoute,
        currentMatch,
        createAnalyticsEvent,
        setResourceMetrics,
        isInitialRender
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, resourcesToTrack);
};
const $5263ffd4ad105e59$export$89f414cc1bd7e863 = ({ createAnalyticsEvent: createAnalyticsEvent })=>// @ts-expect-error - TS2745 - This JSX tag's 'children' prop expects type 'never' which requires multiple children, but only a single child was provided.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lcJyp.SpaStateActionsSubscriber), null, (_, { setResourceMetrics: setResourceMetrics })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5263ffd4ad105e59$export$b5bbbe33c7801196, {
            setResourceMetrics: setResourceMetrics,
            createAnalyticsEvent: createAnalyticsEvent
        }));

});
parcelRegister("4ea83", function(module, exports) {

$parcel$export(module.exports, "setPrefetchStartMark", () => $e69acff038046e8f$export$405fde3eab8e39f6);
$parcel$export(module.exports, "getPrefetchStartMark", () => $e69acff038046e8f$export$cbaceb7ffa84279);
$parcel$export(module.exports, "clearPrefetchStartMarks", () => $e69acff038046e8f$export$d6b0928f07bafe57);
const $e69acff038046e8f$var$prefetchTiming = new Map();
const $e69acff038046e8f$export$405fde3eab8e39f6 = (match)=>{
    const currentMatch = JSON.stringify(match);
    if (!$e69acff038046e8f$var$prefetchTiming.has(currentMatch)) $e69acff038046e8f$var$prefetchTiming.set(currentMatch, {
        startPrefetchTime: Date.now()
    });
};
const $e69acff038046e8f$export$cbaceb7ffa84279 = (match)=>{
    const currentMatch = JSON.stringify(match);
    const { startPrefetchTime: startPrefetchTime } = $e69acff038046e8f$var$prefetchTiming.get(currentMatch) || {
        startPrefetchTime: null
    };
    return startPrefetchTime;
};
const $e69acff038046e8f$export$d6b0928f07bafe57 = (match)=>{
    if (!$e69acff038046e8f$var$prefetchTiming || !$e69acff038046e8f$var$prefetchTiming.keys) return;
    const currentMatch = JSON.stringify(match);
    const keys = Array.from($e69acff038046e8f$var$prefetchTiming.keys());
    keys.forEach((mark)=>{
        if (mark !== currentMatch && $e69acff038046e8f$var$prefetchTiming.has(mark)) $e69acff038046e8f$var$prefetchTiming.delete(mark);
    });
};

});





//# sourceMappingURL=async-global-trackers-components.09968dcc.js.map
